import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useState } from 'react';
import { CartIcon, SearchIcon } from '@chegg-ui/theme';
import { sessionLogger } from '@chegg-ui/utils';
import { IconButton } from '@chegg-ui/button';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { MobileButtonsContainer, CartLink } from '../../styles';
import { ExplicitlyHideSearchBar, NavType } from '../../types';
import HeaderLogoLink from '../HeaderLogoLink';
import getSecondaryNavLinks from '../getSecondaryNavLinks';
import mainNavLinks from '../mainNavLinks';
import { useVisibleLinks } from '../useVisibleEligibility';
import { rioClient } from './../rio';
import MobileHamburgerMenu from './MobileHamburgerMenu';

var MobileHeader = function MobileHeader(_ref) {
  var navType = _ref.navType,
      envUrl = _ref.envUrl,
      pageTrackId = _ref.pageTrackId,
      cartCount = _ref.cartCount,
      children = _ref.children,
      user = _ref.user,
      activeSubLink = _ref.activeSubLink,
      onClickSignIn = _ref.onClickSignIn,
      onClickSignUp = _ref.onClickSignUp,
      onClickSignOut = _ref.onClickSignOut,
      userDataLoading = _ref.userDataLoading;
  var isLegacyHeaderSearch = children !== ExplicitlyHideSearchBar && Object.keys(children.props).includes('serverRenderAsMobile');

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      searchActive = _useState2[0],
      setSearchActive = _useState2[1];

  var adaptiveSearchButtonRef = useRef(null);

  var _useVisibleLinks = useVisibleLinks(
  /* 
   TODO: remove hardcoding of `NavType.study` and allow param to be passed dynamically.
   This is done for the timebeing as on mobile, we cannot determine which links to show based on current 'navType'
   because they all are visible (along with childLinks) directly in the hamburger menu
  */
  NavType.study, mainNavLinks[navType], user),
      links = _useVisibleLinks.links;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileHamburgerMenu, {
    navType: navType,
    envUrl: envUrl,
    pageTrackId: pageTrackId,
    navLinks: links,
    user: user,
    activeSubLink: activeSubLink,
    onClickSignIn: onClickSignIn,
    userDataLoading: userDataLoading // TODO infra: memoize links? https://chegg.atlassian.net/browse/CUI-368
    ,
    userLinks: getSecondaryNavLinks({
      navType: navType,
      user: user,
      onClickSignUp: onClickSignUp,
      onClickSignOut: onClickSignOut
    })
  }), /*#__PURE__*/React.createElement(HeaderLogoLink, {
    envUrl: envUrl,
    navType: navType,
    onClick: function onClick() {
      /**
       * Rio logging for click on chegg logo
       * using force here as there will be redirection after click
       */
      rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
        data: {
          interaction: {
            type: 'select',
            element: {
              name: 'nav header shortcut',
              type: 'link',
              region_name: 'nav header',
              value: navType === NavType.home ? 'Chegg' : "Chegg ".concat(navType)
            }
          }
        }
      }));
      sessionLogger.event(envUrl, pageTrackId, {
        navigation_click: "".concat(navType, "-logo")
      });
    }
  }), /*#__PURE__*/React.createElement(MobileButtonsContainer, null, isLegacyHeaderSearch && /*#__PURE__*/React.createElement(IconButton, {
    ref: adaptiveSearchButtonRef,
    screenReaderOnlyText: "search",
    onClick: function onClick() {
      setSearchActive(true);
    },
    disableHoverAnimation: true,
    size: "medium",
    "data-test": "header-open-search"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), !userDataLoading && cartCount && cartCount >= 0 ? /*#__PURE__*/React.createElement(CartLink, {
    href: "".concat(envUrl, "shoppingcart"),
    "data-test": "header-cart"
  }, /*#__PURE__*/React.createElement(CartIcon, {
    size: "medium",
    numItems: cartCount
  })) : null), isLegacyHeaderSearch && /*#__PURE__*/React.cloneElement(children, {
    searchActive: searchActive,
    pageLocation: navType,
    onCloseMobileSearch: function onCloseMobileSearch() {
      setSearchActive(false);
    }
  }));
};

MobileHeader.displayName = 'MobileHeader';
export default MobileHeader;